import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EventResponse, CompanyResponse } from '../../../../../../../../@shared/models/response.module';
import { EventsService } from '../../../../../../../../@shared/services/events-service';

@Component({
  selector: 'app-wizard-step-payment',
  standalone: false,
  templateUrl: './wizard-step-payment.html',
  styleUrl: './wizard-step-payment.css'
})
export class WizardStepPayment {
  @Input() event: EventResponse | null = null;
  @Input() company: CompanyResponse | null = null;
  @Output() eventUpdated = new EventEmitter<EventResponse>();

  saving = false;

  constructor(private eventService: EventsService) {}

  get isStripeConnected(): boolean {
    return this.company?.stripe_account_status === 'active';
  }

  get isCustomPaymentEnabled(): boolean {
    return this.company?.custom_payment_enabled === true;
  }

  get canConfigurePayment(): boolean {
    return this.isStripeConnected || this.isCustomPaymentEnabled;
  }

  togglePaymentEnabled(eventTarget: Event) {
    if (!this.event) return;

    const enabled = (eventTarget.target as HTMLInputElement).checked;
    this.saving = true;

    this.eventService.editEvent({
      event_id: this.event.event_id,
      payment_enabled: enabled
    }, this.company?.company_id).subscribe({
      next: (response: any) => {
        if (response?.data) {
          this.event = response.data;
          this.eventUpdated.emit(response.data);
        }
        this.saving = false;
      },
      error: () => {
        this.saving = false;
      }
    });
  }

  setPaymentTiming(timing: 'immediate' | 'pay_later') {
    if (!this.event) return;

    this.saving = true;

    this.eventService.editEvent({
      event_id: this.event.event_id,
      payment_timing: timing
    }, this.company?.company_id).subscribe({
      next: (response: any) => {
        if (response?.data) {
          this.event = response.data;
          this.eventUpdated.emit(response.data);
        }
        this.saving = false;
      },
      error: () => {
        this.saving = false;
      }
    });
  }
}
